



































import { Ref, Prop, Component, Vue } from 'vue-property-decorator';
import VAudioElementWrapper from './VAudioElementWrapper.vue';
import VIcon from './VIcon.vue'

@Component({ components: { VAudioElementWrapper, VIcon } })
export default class VAudio extends Vue {
  @Prop({ default: () => [] }) readonly sources!: string[];
  @Prop({ default: () => 1000 }) readonly timeout!: number;
  @Prop({ default: () => false }) readonly canPause!: boolean;
  @Prop({ default: () => '#9FABBC' }) readonly playingColor!: string;
  @Prop({ default: () => 'white' }) readonly contrastColor!: string;

  private loading = false;
  private playing = false;
  private error = false;
  private loaded = 0;
  @Ref('audio-wrapper') readonly audio!: VAudioElementWrapper;

  private timeupdateHandler(event: { progression: number}) {
    if (event) {
      this.loaded = event.progression;
    }
  }

  private errorHandler() {
    this.playing = false;
    this.error = true;
  }

  private timedOutHandler() {
    this.playing = false;
  }

  private pausedHandler() {
    this.playing = false;
  }

  get isBroken() {
    return this.error || this.sources.length === 0;
  }

  get styleProgress() {
    return `background-image: conic-gradient(${this.playingColor} ${this.loaded * 3.6}deg, white 0)`;
  }

  get styleSpinner() {
    return `background: linear-gradient(15deg, ${this.contrastColor} 50%, ${this.playingColor});`;
  }

  get btnClass() {
    if (this.error) {
      return 'btn-outline-secondary btn-error';
    }
    return this.playing ? 'btn-primary' : 'btn-outline-secondary'
  }

  get layerClass() {
    return this.playing ? 'playing' : ''
  }

  protected hasSources(): boolean {
    return this.sources.length > 0;
  }

  protected getAudioElementFromDom(): HTMLAudioElement | null{
    return this.getAudioElementFromDom();
  }

  togglePlay($event: any) {
    if (this.playing) {
      this.audio.pause();
      this.playing = false;
    } else {
      this.audio.play();
      this.playing = true;
    }
  }
}
